<template>

  <div>
    <div class="p-5 pb-0 ai_vehicle_info bg-white rounded_10 mb-4 custom_box_shadow" v-if="vehicleInfo && !isLoading">
      <div class="row">
        <div class="col-md-6">
          <div>
            <h1 class="_theme_font_bold font-weight-bold mb-3">{{ vehicleDisplayName }}</h1>
            <div class="mb-3">
              <p class="d-flex align-items-center">

                <span class="max_100">
                  Exterior :
                </span>
                <span v-if="vehicleInfo.extColorHexCode || vehicleInfo.ext_Color_Generic"
                  class="mr-2 color-box d-inline-block" :style="getVehicleIntExteriorColorStyle(
                    vehicleInfo.extColorHexCode,
                    vehicleInfo.ext_Color_Generic
                  )
                    ">

                </span>
                <span> {{ vehicleInfo.exteriorColor }}</span>


              </p>
              <p class="d-flex align-items-center">
                <span class="max_100">
                  Interior :
                </span>
                <span v-if="vehicleInfo.intColorHexCode ||
                  vehicleInfo.int_Color_Generic" class="mr-2 color-box d-inline-block" :style="getVehicleIntExteriorColorStyle(
                    vehicleInfo.intColorHexCode,
                    vehicleInfo.int_Color_Generic
                  )"></span>
                <span>{{ vehicleInfo.interiorColor }}</span>
              </p>

            </div>

            <div class="mb-3">
              <p><small>VIN: {{ vehicleInfo.vin }}, Stock #{{ vehicleInfo.stock }}</small></p>
              <p><small>Model Code: {{ vehicleInfo.modelNumber }}</small></p>
            </div>



            <div v-if="Incentives.length" class="mb-3">
              <p>
                <span class="max_100 font-weight-bold">Incentives:</span>
              <div v-for="(item, index) in Incentives" :key="index" class="mt-2">
                <div class="d-flex align-items-center justify-content-between mb-1">
                  <small class="max_100">
                    {{ item.NameDetailed }}
                  </small>
                  <span v-if="item.Amount" class="ml-2">
                    ${{ item.Amount }}
                  </span>

                </div>
              </div>
              </p>

            </div>


            <!-- <div class="mb-3 price_table">
            <p>
              <span>New MSRP Label</span> <span>$33,405</span>
            </p>
            <p>
              <span>New Discount Label</span> <span>-$1350</span>
            </p>
            <p>
              <span>Pro Pack</span> <span>+$999</span>
            </p>
            <p>
              <span>All Discount</span> <span>-$500</span>
            </p>
            <p>
              <span>Accessories</span> <span>+$500</span>
            </p>
          </div> -->
            <!-- <h1 class="font-weight-bold mb-0">$33,054</h1>
          <small class="text-black-50">Please excludes tax, tags and dealer fees. offer expires - 3/5/2025</small> -->
          </div>


        </div>
        <div class="col-md-6 text-center" v-if="vehicleInfo?.firstPhotoUrl">
          <div class="rounded_10 img_card">
            <img class="img-fluid rounded_10" :src="vehicleInfo.firstPhotoUrl" alt="">
          </div>
        </div>
      </div>

    </div>
    <div v-else>
      <TvmPreLoader />
    </div>
  </div>
</template>
<script>


import { mapState } from 'pinia';
import { ExpressPaymentsBaseService } from '../../../../../../js/Common/Payments/ExpressPaymentsBaseService';
import { ExpressPayments } from '../../../../Services/Payments/ExpressPayments';
import { useIncentiveStore } from '../../../../store/IncentivesStore/IncentivesStore';
import TvmPreLoader from '../../TvmPreLoader/TvmPreLoader.vue';
import { Payments } from '../../../../Services/Payments/Payments';
import { usePaymentSettingsStore } from '../../../../store/PaymentSettings/PaymentsettingsStore';
import axios from 'axios';


export default {
  props: ['botResponse', 'isLastIndex', 'chatThemeSettings'],
  data() {
    return {
      vehicleInfo: null,
      isLoading: true,
    };
  },
  mounted() {
    this.getVehicleInfo();
  },

  methods: {
    async getVehicleInfo() {
      this.isLoading = true;
      const { zipCode, dealerId, styleId, make, model, year, type } = this.botResponse?.component?.value || {};
      if (this.vin) {
        try {
          window.vdpAccountId = dealerId;

          const url = 'https://stage.websites.api.teamvelocityportal.com';


          const apiUrl = `${url}/tvm-services/inventory/vehicledetails-by-vin?AccountId=${dealerId}&CampaignId=95&Vin=${this.vin}`;

          // const vehicleDetails = await axios.get(apiUrl);

          try {
            const response = await axios.get(apiUrl);
            const vehicleDetails = response.data;
            this.vehicleInfo = vehicleDetails;
            // use vehicleDetails as needed
          } catch (error) {
            console.error("Error fetching vehicle details:", error);
          }
          console.log(vehicleDetails, 'vehicleDetails');

          this.isLoading = false;
          const paramsData = {
            vin: this.vin,
            styleId: 446372,
            accountId: dealerId,
            make: make,
            model: model,
            year: year,
            type: this.vehicleInfo?.type || 'new',
            zipcode: zipCode
          };

          await this.IncentiveStore.getPaymentSettings(paramsData);
          await this.IncentiveStore.getConditionalRebates(paramsData);
          // const paymentSettingsStore = usePaymentSettingsStore();
          // paymentSettingsStore.setpaymentsettings(paramsData);
          // const data = Payments.getMsrpDetails(this.getpaymentsettings, 'cash');
          // console.log(data, this.getpaymentsettings, 'dataaaa');

        } catch (err) {
          console.log(err);
          this.isLoading = false;
        }
      }

      // const incentives = await ExpressPaymentsBaseService.getSpecialIncentives('cash', zipCode);


      // console.log(this.setFordDirectQualifiedIncentives, 'incentives');



    },
    getVehicleIntExteriorColorStyle(colorHexCode, colorGeneric) {
      if (colorHexCode === '' && colorGeneric === '') {
        return {
          'background-color': 'transparent',
          border: '1px solid #ccc',
        };
      }

      const color = colorHexCode ? `#${colorHexCode}` : colorGeneric;
      return { 'background-color': `${color} !important`, 'border-color': `${color} !important` };
    },
  },
  computed: {
    vin() {
      return this.botResponse?.component?.value?.vin || '';
    },
    vehicleDisplayName() {
      if (!this.vehicleInfo) {
        return '';
      }
      const { year, make, model, trim } = this.vehicleInfo;
      return [year, make, model, trim].filter(Boolean).join(' ');
    },
    IncentiveStore() {
      return useIncentiveStore()
    },
    Incentives() {
      let incentives = [];
      if (this.IncentiveStore.fordDirectQualifiedIncentives?.length > 0) {
        incentives = this.IncentiveStore.fordDirectQualifiedIncentives;
      } else {
        incentives = this.IncentiveStore.conditionalRebates;
      }
      // console.log(this.IncentiveStore.fordDirectQualifiedIncentives, 'incentives');
      if (incentives?.length > 0) {
        return incentives?.filter((t) => t.OfferType?.toLowerCase() === 'all') || [];
        console.log(incentives, 'incentives');
      }
      return [];

    },
    ...mapState(usePaymentSettingsStore, ['getpaymentsettings']),
  },
  components: {
    TvmPreLoader,
  },
}
</script>
<style scoped>
.ai_vehicle_info h1 {
  font-size: 1.7rem !important;
}

.ai_vehicle_info p {
  margin-bottom: 4px;
}

.price_table {
  max-width: 400px;
}

.price_table p {
  display: flex;
  justify-content: space-between;
}

.img_card img {
  max-height: 400px;
  display: block;
  float: right;
}

.max_100 {
  min-width: 100px;
  display: inline-block;
}

.color-box {
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  border-radius: 50%;
}
</style>
